export default __webpack_public_path__ + "static/media/minus.d7b04fb6.svg";